import {Injectable, inject} from "@angular/core";
import {BringozToastService} from "../../../commons/services/bringoz-toast.service";
import {TRAIN_VOUCHER_CREATE_ERROR} from "../constants/threepl-train.constant";

interface ToastMessage {
  body: string;
  details?: string;
}

@Injectable({providedIn: "root"})
export class ThreePLTrainAlertsService {
  private readonly toast = inject<BringozToastService>("bringozToastService" as never);

  trainVoucherCreateError(): void {
    this.toast.error({body: TRAIN_VOUCHER_CREATE_ERROR, details: "SOMETHING_WENT_WRONG"});
  }

  trainVoucherCreateMissingRelatedDepotsError(): void {
    this.toast.error({body: "THREEPL_TRAIN_VOUCHER_CREATE_MISSING_RELATED_DEPOTS_ERROR", details: TRAIN_VOUCHER_CREATE_ERROR});
  }

  trainVoucherCreateMissingSupplierError(): void {
    this.toast.error({body: "THREEPL_TRAIN_VOUCHER_CREATE_MISSING_SUPPLIER_ERROR", details: TRAIN_VOUCHER_CREATE_ERROR});
  }

  trainVoucherCreateMissingProviderError(): void {
    this.toast.error({body: "THREEPL_TRAIN_VOUCHER_CREATE_MISSING_PROVIDER_ERROR", details: TRAIN_VOUCHER_CREATE_ERROR});
  }

  trainVoucherCreateMissingThreePLProviderSettingsError(): void {
    this.toast.error({body: "THREEPL_TRAIN_VOUCHER_CREATE_MISSING_3PL_PROVIDER_SETTINGS_ERROR", details: TRAIN_VOUCHER_CREATE_ERROR});
  }

  trainVoucherCreateMissingThreePLBaseUrlError(): void {
    this.toast.error({body: "THREEPL_TRAIN_VOUCHER_CREATE_MISSING_3PL_BASE_URL_ERROR", details: TRAIN_VOUCHER_CREATE_ERROR});
  }

  trainVoucherCreateMissingThreePLKeyError(): void {
    this.toast.error({body: "THREEPL_TRAIN_VOUCHER_CREATE_MISSING_3PL_KEY_ERROR", details: TRAIN_VOUCHER_CREATE_ERROR});
  }

  trainVoucherCreateMissingThreePLSecretError(): void {
    this.toast.error({body: "THREEPL_TRAIN_VOUCHER_CREATE_MISSING_3PL_SECRET_ERROR", details: TRAIN_VOUCHER_CREATE_ERROR});
  }

  trainVoucherCreateMissingExtraDataError(): void {
    this.toast.error({body: "THREEPL_TRAIN_VOUCHER_CREATE_MISSING_EXTRA_DATA_ERROR", details: TRAIN_VOUCHER_CREATE_ERROR});
  }

  trainVoucherUpdateSuccess(): void {
    this.toast.success({body: "THREEPL_TRAIN_VOUCHER_UPDATE_SUCCESS"});
  }

  trainVoucherUpdateError(): void {
    this.toast.error({body: "THREEPL_TRAIN_VOUCHER_UPDATE_ERROR", details: "SOMETHING_WENT_WRONG"});
  }
}
